let url = "https://api.boritta.com/admin";

// let url = "http://192.168.0.102:3075/admin";
export let cdnUrl = "https://cdnapi.boritta.com/admin";
// export let cdnUrl = "http://192.168.0.102:3404/admin";

export let globalCdnUrl = "https://cdnapi.boritta.com/admin";
export let apiUrl = "https://cdnapi.boritta.com/admin";
export default url;
